module.exports = __webpack_public_path__ + "static/logo-c4bf120a6d4aef4e46297288b02cc803.svg";